import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Справочники", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Авторизация", -1)
const _hoisted_3 = {
  key: 0,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_4 = { style: {"flex-basis":"50px","text-align":"left","margin":"0 0 0 .7rem"} }
const _hoisted_5 = {
  key: 0,
  style: {"text-align":"left","line-height":".8rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataLine = _resolveComponent("DataLine")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_Tickets = _resolveComponent("Tickets")!
  const _component_Coin = _resolveComponent("Coin")!
  const _component_Memo = _resolveComponent("Memo")!
  const _component_MessageBox = _resolveComponent("MessageBox")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Van = _resolveComponent("Van")!
  const _component_OfficeBuilding = _resolveComponent("OfficeBuilding")!
  const _component_Collection = _resolveComponent("Collection")!
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")!
  const _component_user = _resolveComponent("user")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_Lock = _resolveComponent("Lock")!
  const _component_ArrowLeftBold = _resolveComponent("ArrowLeftBold")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_text = _resolveComponent("el-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_el_menu, {
          key: 0,
          collapse: _ctx.isCollapse,
          style: {"border-right":"0"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, { index: "dashboard" }, {
              title: _withCtx(() => [
                _createTextVNode("Сводка")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_DataLine)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, {
              index: "schedule",
              onClick: _cache[0] || (_cache[0] = () => _ctx.onMenuTabClick(_ctx.tabsDict.schedule))
            }, {
              title: _withCtx(() => [
                _createTextVNode("График загрузки")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Tickets)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, {
              index: "orders",
              onClick: _cache[1] || (_cache[1] = () => _ctx.onMenuTabClick(_ctx.tabsDict.orders))
            }, {
              title: _withCtx(() => [
                _createTextVNode("Заказ-наряд")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Coin)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "1" }, {
              title: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Memo)
                  ]),
                  _: 1
                }),
                _hoisted_1
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_sub_menu, { index: "items" }, {
                      title: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_MessageBox)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Запчасти ")
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_menu_item, {
                          index: "items",
                          onClick: _cache[2] || (_cache[2] = () => _ctx.onMenuTabClick(_ctx.tabsDict.items))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Запчасти ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, {
                          index: "itemsgroups",
                          onClick: _cache[3] || (_cache[3] = () => _ctx.onMenuTabClick(_ctx.tabsDict.itemsGroups))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Группы запчастей ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, {
                      index: "employees",
                      onClick: _cache[4] || (_cache[4] = () => _ctx.onMenuTabClick(_ctx.tabsDict.employees))
                    }, {
                      title: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Avatar)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Сотрудники ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_sub_menu, { index: "vehicles" }, {
                      title: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Van)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Автомобили ")
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_menu_item, {
                          index: "vehicles-customers",
                          onClick: _cache[5] || (_cache[5] = () => _ctx.onMenuTabClick(_ctx.tabsDict.vehicles))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Автомобили контрагентов ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, {
                          index: "vehicles-models",
                          onClick: _cache[6] || (_cache[6] = () => _ctx.onMenuTabClick(_ctx.tabsDict.vehicleModels))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Модели ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, {
                          index: "vehicles-manufacturers",
                          onClick: _cache[7] || (_cache[7] = () => _ctx.onMenuTabClick(_ctx.tabsDict.vehicleManufacturers))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Марки ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_sub_menu, { index: "jobs" }, {
                      title: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_OfficeBuilding)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Работы ")
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_menu_item, {
                          index: "jobs",
                          onClick: _cache[8] || (_cache[8] = () => _ctx.onMenuTabClick(_ctx.tabsDict.jobs))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Сервисные работы ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_sub_menu, { index: "jobComponents" }, {
                          title: _withCtx(() => [
                            _createTextVNode(" Сервисные компоненты ")
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_menu_item, {
                              index: "jobComponents",
                              onClick: _cache[9] || (_cache[9] = () => _ctx.onMenuTabClick(_ctx.tabsDict.jobComponents))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Компонеты (узлы) ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_menu_item, {
                              index: "jobComponentGroups",
                              onClick: _cache[10] || (_cache[10] = () => _ctx.onMenuTabClick(_ctx.tabsDict.jobComponentGroups))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Группы компонетов (узлов) ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, {
                          index: "jobOperations",
                          onClick: _cache[11] || (_cache[11] = () => _ctx.onMenuTabClick(_ctx.tabsDict.jobOperations))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Сервисные операции ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, {
                          index: "jobCategories",
                          onClick: _cache[12] || (_cache[12] = () => _ctx.onMenuTabClick(_ctx.tabsDict.jobCategories))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Категории работ ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, {
                          index: "jobGroups",
                          onClick: _cache[13] || (_cache[13] = () => _ctx.onMenuTabClick(_ctx.tabsDict.jobGroups))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Группы работ ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, {
                      index: "counterparties",
                      onClick: _cache[14] || (_cache[14] = () => _ctx.onMenuTabClick(_ctx.tabsDict.counterparties))
                    }, {
                      title: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Collection)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Контрагенты ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, {
              index: "users",
              onClick: _cache[15] || (_cache[15] = () => _ctx.onMenuTabClick(_ctx.tabsDict.users))
            }, {
              title: _withCtx(() => [
                _createTextVNode("Пользователи")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_user)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["collapse"]))
      : (_openBlock(), _createBlock(_component_el_menu, {
          key: 1,
          "default-active": "signin",
          style: {"border-right":"0"},
          router: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, { index: "signin" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Lock)
                  ]),
                  _: 1
                }),
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })),
    _createElementVNode("div", {
      style: _normalizeStyle([{"position":"absolute","bottom":"0"}, {'width': `${_ctx.width}px`}])
    }, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, null, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass({'left-menu-toggler': true, 'rotate': _ctx.isCollapse}),
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onToggleMenuStyleClick && _ctx.onToggleMenuStyleClick(...args)))
              }, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowLeftBold)
                  ]),
                  _: 1
                })
              ], 2)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_avatar, { src: "data:image/png;base64,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" })
            ]),
            (!_ctx.isCollapse)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_el_text, {
                    size: "small",
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.store.getters.user.login), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_text, {
                      size: "small",
                      type: "info"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(`${_ctx.store.getters.user.employee.lastname} ${_ctx.store.getters.user.employee.firstname?.substring(0,1)}${_ctx.store.getters.user.employee.firstname?.length ? '.' : ''}`), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ], 64))
}